export enum CalculationMethod {
  INGREDIENTS = 0,
  MAPPED,
  SET_TO_ZERO,
  SET_TO_UNKNOWN,
}
